import { z } from "zod";
export const CANCELLATION_EVIDENCE_MIME_TYPES = ["application/pdf", "image/png", "image/jpeg"];
export const cancellationEvidenceUploadSchema = z.object({
    filename: z.string().min(1).max(255),
    mime_type: z.enum(CANCELLATION_EVIDENCE_MIME_TYPES, {
        message: "Only PDF, PNG and JPEG files are allowed",
    }),
});
